import { Bank } from '@core/model/domain/bank';
import { OkVal } from '@core/model/framework/Result/OkResult';
import { Usecase } from '@core/model/framework/usecase';
import type { BankService } from '@core/model/service/bankService';
import { SERVICE_ID } from '@di/serviceId';
import { inject, injectable } from 'inversify';

export type GetBanksOutput = Promise<OkVal<Bank[]>>;

@injectable()
export class GetBanks implements Usecase<void, GetBanksOutput> {
  constructor(
    @inject(SERVICE_ID.bankService)
    private readonly bankService: BankService
  ) {}
  async execute(): GetBanksOutput {
    return this.bankService.getBanks();
  }
}
